import { btn_c_link, btn_li_sm } from '@xpertdox_js/xdstyle';

export default {
  list: {
    margin: 0,
    marginBottom: 10,
    paddingLeft: '0',
    listStyle: 'none'
  },
  listItem: {
    color: 'rgb(68, 84, 97)',
    fill: 'rgb(68, 84, 97)',
    padding: '8px 0px 8px 18px',
    width: '100%',
    display: 'block'
  },
  link: {
    ...btn_li_sm,
    ...btn_c_link.base,
    paddingLeft: 0,
    paddingRight: 0,
  },
  linkHov: {
    // ...btn_c_link.hover,
    backgroundColor: 'rgba(0, 0, 0, 0.06)',
    width: '14%'
  },
  linkText: {
    display: 'inline-block',
    marginTop: '2px',
    fontSize: '1.5em'
  }
}
